import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        productCategories: false
      },
      options: {
        productCategories: []
      },
      selected: {
        productCategory: ''
      },
      editable: {
        productCategory: ''
      }
    }
  },

  methods: {

    async getProductCategories (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.productCategory
      const fetching = context.fetching?.productCategories
      const options = context.options?.productCategories

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.productCategories = true
      context.selected.productCategory = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getProductCategories(filters).then(
        ({ data }) => {
          context.options.productCategories = data
        }
      ).catch(() => {
        context.options.productCategories = []
      }).finally(() => {
        context.fetching.productCategories = false
      })
    },

    async searchProductCategories (search, loading) {
      this.searchProductCategoriesProvider(this, search, loading)
    },

    searchProductCategoriesProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.productCategories, {
          keys: ['category_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getProductCategories(filters).then(
            ({ data }) => {
              options.productCategories = data
            }
          ).catch(() => {
            options.productCategories = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
